import { List } from 'immutable';
import { isEmpty } from 'lodash';

export function itemsIntersect(arr1, arr2) {
  const stringArray1 = arr1.map(String);
  const stringArray2 = arr2.map(String);

  return stringArray1.some((value) => stringArray2.includes(value));
}

export const filterConnectedTickets = (event, showAttendeeInputsPerTicket, ticketsInCart, ticketId) =>
  (event.get('questions') || List()).toJS().filter((question) => {
    const connectedTicketIds = question.connected_ticket_ids || [];
    if (isEmpty(connectedTicketIds)) return true;
    // if ticket in cart has 2 and we are attendee number three then omot that ticket
    if (showAttendeeInputsPerTicket) {
      return connectedTicketIds.includes(ticketId);
    }
    return itemsIntersect(connectedTicketIds, ticketsInCart);
  });
